export type UserRole = 'user' | 'moderator' | 'admin' | 'system_admin';

export enum Permission {
  // Junior (user) permissions
  UPLOAD_DOCUMENTS = 'upload_documents',
  CREATE_COMMENTS = 'create_comments',
  PROPOSE_DECISIONS = 'propose_decisions',
  
  // Senior (moderator) permissions
  CHANGE_FINDING_STATUS = 'change_finding_status',
  MODULE_SIGNOFF = 'module_signoff',
  
  // Admin/Partner permissions
  FINAL_CASE_SIGNOFF = 'final_case_signoff',
  EXPORT_PREMIUM_REPORT = 'export_premium_report',
  GENERATE_REPORT = 'generate_report',
}

// Role hierarchy: user < moderator < admin < system_admin
const roleHierarchy: Record<UserRole, number> = {
  user: 1,      // Junior
  moderator: 2, // Senior
  admin: 3,     // Admin/Partner
  system_admin: 4, // System Administrator
};

// Permissions for each role
const rolePermissions: Record<UserRole, Permission[]> = {
  user: [
    Permission.UPLOAD_DOCUMENTS,
    Permission.CREATE_COMMENTS,
    Permission.PROPOSE_DECISIONS,
  ],
  moderator: [
    Permission.UPLOAD_DOCUMENTS,
    Permission.CREATE_COMMENTS,
    Permission.PROPOSE_DECISIONS,
    Permission.CHANGE_FINDING_STATUS,
    Permission.MODULE_SIGNOFF,
  ],
  admin: [
    Permission.UPLOAD_DOCUMENTS,
    Permission.CREATE_COMMENTS,
    Permission.PROPOSE_DECISIONS,
    Permission.CHANGE_FINDING_STATUS,
    Permission.MODULE_SIGNOFF,
    Permission.FINAL_CASE_SIGNOFF,
    Permission.EXPORT_PREMIUM_REPORT,
    Permission.GENERATE_REPORT,
  ],
  system_admin: [
    // System admins har alla permissions plus system-specifika
    Permission.UPLOAD_DOCUMENTS,
    Permission.CREATE_COMMENTS,
    Permission.PROPOSE_DECISIONS,
    Permission.CHANGE_FINDING_STATUS,
    Permission.MODULE_SIGNOFF,
    Permission.FINAL_CASE_SIGNOFF,
    Permission.EXPORT_PREMIUM_REPORT,
    Permission.GENERATE_REPORT,
  ],
};

export const hasPermission = (role: UserRole | null, permission: Permission): boolean => {
  if (!role) return false;
  return rolePermissions[role]?.includes(permission) || false;
};

export const getRoleDisplayName = (role: UserRole | null): string => {
  switch (role) {
    case 'user':
      return 'Junior Revisor';
    case 'moderator':
      return 'Senior Revisor';
    case 'admin':
      return 'Admin/Partner';
    case 'system_admin':
      return 'Systemadministratör';
    default:
      return 'Okänd roll';
  }
};